<cf-storybook-shell-header></cf-storybook-shell-header>

<div class="button-container">
  <cf-storybook-shell-button *ngFor="let app of apps" [name]="app"></cf-storybook-shell-button>
</div>
